import React, { Fragment, useCallback, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { JoinSecondary } from '../../components-legacy/Buttons/JoinNow';
import MobileMenu from '../../components/MobileMenu/MobileMenu';
import { Colors, EnrollmentEndsAt } from '../../constants';
import { Wordmark } from '../../icons/Icons';
import { media } from '../style-utils';
import { URLs, Counts } from '../../constants';
import * as dateFns from 'date-fns';

const FullHeader = (props) => (
  <Fragment>
    <Header className={props.className}>
      <WordmarkLink />
      <CountdownGroup />
      <UserButtons />
    </Header>
    {!props.hideNav && <MobileMenu color={Colors.Primary} />}
  </Fragment>
);

const WordmarkLink = function() {
  return (
    <HeaderLink to="/">
      <HeaderWordmark />
    </HeaderLink>
  );
};

const CountdownGroup = function() {
  // Class is starting soon...Enrollment closing in [Countdown] - Only 75 spots available!
  // Sticky Countdown Banner [ALT]: Class is full - click here to join the waitlist

  const enrollmentOpen = EnrollmentEndsAt > new Date();
  let text = 'Class is full - join the waitlist';
  if (enrollmentOpen === true) {
    text = 'Enrollment closing soon';
  }

  return (
    <CountdownWrapper>
      <CountdownText>{text}</CountdownText>
      {enrollmentOpen && <CountdownClock />}
    </CountdownWrapper>
  );
};

const CountdownWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const CountdownText = styled.div`
  text-align: right;

  max-width: 15rem;
  padding-right: 0.6rem;
  line-height: 0.9em;

  ::before {
    /* ${(props) => `content: ${props.label}`}; */
    /* content: 'Only ${Counts.RemainingSpots} spots available'; */
  }

  ${media.tabletLandscapeAndUp`
    max-width: unset;
    padding-right: 1.6rem;
    ::before {
      /* ${(props) => `content: ${props.label}`}; */
      /* content: 'Class is starting soon... Only ${Counts.RemainingSpots} spots available'; */
    }
  `}
`;

function calculateCountdownText() {
  let from = new Date();
  let to = EnrollmentEndsAt;

  if (from > to) {
    return '0d 0h 0m 0s';
  }

  let days = Math.floor(dateFns.differenceInDays(to, from));
  to = dateFns.subDays(to, days);
  let hours = Math.floor(dateFns.differenceInHours(to, from));
  to = dateFns.subHours(to, hours);
  let minutes = Math.floor(dateFns.differenceInMinutes(to, from));
  to = dateFns.subMinutes(to, minutes);
  let seconds = Math.floor(dateFns.differenceInSeconds(to, from));

  return `${days}d ${hours}h ${minutes}m ${seconds}s`;
}

const CountdownClock = function() {
  let getText = useCallback(calculateCountdownText);
  let [text, setText] = useState(getText());

  useEffect(() => {
    let id = window.setTimeout(() => setText(getText()), 1000);
    return () => window.clearTimeout(id);
  });

  return <CountdownBox>{text}</CountdownBox>;
};

const CountdownBox = styled.div`
  background-color: var(--colorPrimaryMedium);
  width: 16rem;
  height: 4.5rem;
  border-radius: 0.5rem;

  font-size: 1.6rem;
  line-height: calc(2.2 / 2.2 * 1em);
  letter-spacing: calc(-0.4 / 2.2 * 0.1em);
  color: var(--colorWhite);

  display: flex;
  justify-content: center;
  align-items: center;

  ${media.tabletPortraitAndUp`
    font-size: 2.2rem;
  `}
`;

const UserButtons = function() {
  return (
    <UserGroup>
      <SignInLink href={URLs.login}>Sign In</SignInLink>
      <StyledJoinSecondary href="#pricing" />
    </UserGroup>
  );
};

const StyledJoinSecondary = styled(JoinSecondary)`
  width: 18.5rem;
  height: 4.4rem;

  font-size: 1.8rem;
  font-weight: 700;
`;

const UserGroup = styled.div`
  display: none;

  ${media.desktopAndUp`
    display: block;
  `}
`;

const SignInLink = styled.a`
  padding-right: 2rem;
  color: var(--colorBlack);
  opacity: 0.5;
  :hover {
    opacity: 1;
  }

  :visited {
    color: var(--colorBlack);
  }
`;

const Header = styled.header`
  z-index: 999;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 7.6rem;

  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 1.6rem;
  padding-right: 1.6rem;

  background-color: var(--colorWhite);
  color: #000000;

  box-shadow: 0 0.2rem 1.5rem 0 rgba(0,0,0,0.50);

  ${media.largePhoneAndUp`
    /* padding: 2.5rem; */
  `}

  ${media.tabletLandscapeAndUp`
    /* padding: 2.5rem 3.5rem; */
  `}

  ${media.desktopAndUp`
    height: 8.5rem;
  `}
`;

export default FullHeader;

const HeaderLink = styled(Link)`
  position: relative;
  z-index: 10;
  flex: 0 0 auto;
  color: currentColor;
`;

const HeaderWordmark = styled(Wordmark).attrs(({ color }) => ({
  // we can define static props
  color: 'black',
}))`
  display: block;
  width: auto;
  height: 4.5rem;
  text-align: center;
  z-index: 1;

  ${media.tabletLandscapeAndUp`
    width: auto;
    height: 5rem;
    margin-right: 1rem;
  `};
`;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js